export default {
  store: {
    state: {
      paginations: [],
    },
    actions: {
      PUSH_PAGINATION({ commit }, pagination) {
        commit('PUSH_PAGINATION', pagination)
      },
      PATCH_PAGINATION({ commit }, args) {
        commit('PATCH_PAGINATION', args)
      },
      // SET_PAGE({ commit }, args) {
      //   commit('PATCH_PAGINATION', args)
      // },
      // SET_SORT({ commit }, args) {
      //   commit('PATCH_PAGINATION', args)
      // },
      // SET_FILTER({ commit }, args) {
      //   commit('PATCH_PAGINATION', args)
      // },
      // SET_FILTER_STRING({ commit }, args) {
      //   commit('PATCH_PAGINATION', args)
      // },
    },
    mutations: {
      PUSH_PAGINATION(state, pagination) {
        state.paginations.push(pagination)
      },
      PATCH_PAGINATION(_, { pagination, ...patch }) {
        Object
          .keys(patch)
          .forEach((key) => {
            pagination[key] = patch[key]
          })
      },
    },
    getters: {
      getPagination: ({ paginations }) => paginationName =>
        paginations.find(pagination => pagination.name === paginationName),
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pagination.js